import React from 'react';
import './css/style.css';
import { AuthProvider } from './auth/AuthContext';
import Routes from './Routes/routes'; 

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </div>
  );
}

export default App;
